<template>
  <div class="file-catalog-panel">
    <el-form :model="query" size="small" class="search-form" label-position="right" @submit.native.prevent>
      <el-row :gutter="16" class="search-grid">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="一级文件夹" label-width="84px">
            <el-input v-model="query.folderLevel1" clearable placeholder="如：程序文件" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="二级文件夹" label-width="84px">
            <el-input v-model="query.folderLevel2" clearable placeholder="二级目录名" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="文件编号" label-width="84px">
            <el-input v-model="query.fileCode" clearable placeholder="如：RY-PD-001" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="文件名称" label-width="84px">
            <el-input v-model="query.fileName" clearable placeholder="文件名称" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="版本号" label-width="84px">
            <el-input v-model="query.version" clearable placeholder="如：G0" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="编制人" label-width="84px">
            <el-input v-model="query.preparer" clearable placeholder="编制人" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="文件状态" label-width="84px">
            <el-select v-model="query.status" clearable placeholder="全部" style="width: 100%;">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label-width="0" class="search-actions">
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="sort-tip">
      <i class="el-icon-rank"></i>
      拖拽左侧手柄可调整本页排序；排序按全局 sort_no 生效（越小越靠前）
    </div>

    <div class="catalog-table-wrap">
    <el-table
      ref="catalogTable"
      :data="tableData"
      v-loading="loading || sorting"
      row-key="fileId"
      border
      stripe
      height="100%"
      class="catalog-table"
    >
      <el-table-column label="" width="46" align="center" class-name="drag-col">
        <template>
          <span class="drag-handle" title="拖拽排序">
            <i class="el-icon-rank"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sortNo" label="排序号" width="70" align="center" />
      <el-table-column prop="folderLevel1" label="一级文件夹" min-width="110" show-overflow-tooltip />
      <el-table-column prop="folderLevel2" label="二级文件夹" min-width="110" show-overflow-tooltip />
      <el-table-column label="文件目录" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.folderPath || formatFolderPath(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="fileCode" label="文件编号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="fileName" label="程序文件名称" min-width="180" show-overflow-tooltip />
      <el-table-column prop="version" label="版本号" width="90" align="center" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="statusMap[scope.row.status] != null"
            :type="statusMap[scope.row.status][0]"
            size="mini"
          >{{ statusMap[scope.row.status][1] }}</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="effectiveDate" label="生效日期" width="120" align="center" />
      <el-table-column prop="createDate" label="上传日期" width="160" align="center" />
      <el-table-column prop="preparer" label="编制" width="90" align="center" show-overflow-tooltip />
      <el-table-column prop="reviewer" label="审核" width="90" align="center" show-overflow-tooltip />
      <el-table-column prop="approver" label="批准" width="90" align="center" show-overflow-tooltip />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="预览权限" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.hasViewPermission ? 'success' : 'info'" size="mini">
            {{ scope.row.hasViewPermission ? '有权限' : '无权限' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.hasViewPermission"
            type="text"
            size="small"
            @click="openPreview(scope.row)"
          >预览</el-button>
          <el-button
            type="text"
            size="small"
            @click="openFileLocation(scope.row)"
          >打开位置</el-button>
          <el-button
            v-if="canEdit"
            type="text"
            size="small"
            @click="openEdit(scope.row)"
          >编辑版本</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <el-pagination
      class="catalog-pagination"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="query.curPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <el-dialog
      :title="'预览 - ' + (previewRow.fileName || '')"
      :visible.sync="previewVisible"
      width="90%"
      top="4vh"
      append-to-body
      :close-on-click-modal="false"
      custom-class="catalog-preview-dialog"
      @closed="closePreview"
    >
      <div v-if="previewUnsupported" class="catalog-preview-unsupported">
        <p>该文件类型暂不支持在线预览</p>
      </div>
      <iframe
        v-else-if="previewUrl"
        :key="previewKey"
        :src="previewUrl"
        frameborder="0"
        class="catalog-preview-iframe"
      />
    </el-dialog>

    <el-dialog title="编辑文件台账信息" :visible.sync="editVisible" width="560px" append-to-body :close-on-click-modal="false">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px" size="small">
        <el-form-item label="文件名称" prop="fileName">
          <el-input v-model="editForm.fileName" maxlength="200" />
        </el-form-item>
        <el-form-item label="文件编号" prop="fileCode">
          <el-input v-model="editForm.fileCode" maxlength="64" placeholder="如：RY-PD-001" />
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="editForm.version" maxlength="32" placeholder="如：G0 / V1.0" />
        </el-form-item>
        <el-form-item label="生效日期" prop="effectiveDate">
          <el-date-picker
            v-model="editForm.effectiveDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择生效日期"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="编制人" prop="preparer">
          <select-member-modal
            v-model="editForm.preparer"
            placeholder="请选择编制人"
            :multiple="false"
            :trigger-change="true"
            value-field="fullName"
            :popover-z-index="5000"
          />
        </el-form-item>
        <el-form-item label="审核人" prop="reviewer">
          <select-member-modal
            v-model="editForm.reviewer"
            placeholder="请选择审核人"
            :multiple="false"
            :trigger-change="true"
            value-field="fullName"
            :popover-z-index="5000"
          />
        </el-form-item>
        <el-form-item label="批准人" prop="approver">
          <select-member-modal
            v-model="editForm.approver"
            placeholder="请选择批准人"
            :multiple="false"
            :trigger-change="true"
            value-field="fullName"
            :popover-z-index="5000"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNo">
          <el-input-number v-model="editForm.sortNo" :min="0" :max="999999999" controls-position="right" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="saveEdit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'fileCatalogPanel',
  components: {
    SelectMemberModal: () => import('@/components/SelectMemberModal.vue')
  },
  props: {
    /** 与「默认白名单」相同：addFileButton 或 canOperateAll */
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      sorting: false,
      tableData: [],
      total: 0,
      dragIndex: -1,
      statusMap: {
        0: ['warning', '草稿'],
        1: ['', '待审核'],
        2: ['success', '已生效'],
        '-1': ['danger', '已废止'],
        '-2': ['danger', '审核驳回']
      },
      statusOptions: [
        { value: 0, label: '草稿' },
        { value: 1, label: '待审核' },
        { value: 2, label: '已生效' },
        { value: -1, label: '已废止' },
        { value: -2, label: '审核驳回' }
      ],
      query: {
        folderLevel1: '',
        folderLevel2: '',
        fileCode: '',
        fileName: '',
        version: '',
        preparer: '',
        status: null,
        curPage: 1,
        pageSize: 20
      },
      editVisible: false,
      previewVisible: false,
      previewRow: {},
      previewUrl: '',
      previewKey: 0,
      previewUnsupported: false,
      editForm: {
        fileId: '',
        fileName: '',
        fileCode: '',
        version: '',
        effectiveDate: '',
        preparer: '',
        reviewer: '',
        approver: '',
        remark: '',
        sortNo: 0
      },
      editRules: {
        version: [{ required: true, message: '请输入版本号', trigger: 'blur' }]
      },
      _dragBound: false
    }
  },
  created() {
    this.loadData()
  },
  updated() {
    this.bindRowDrag()
  },
  beforeDestroy() {
    this.unbindRowDrag()
  },
  methods: {
    loadData() {
      this.loading = true
      const payload = {
        ...this.query,
        curPage: Number(this.query.curPage) || 1,
        pageSize: Number(this.query.pageSize) || 20
      }
      this.$HttpService.post('/file-info/catalog/page', payload)
        .then(res => {
          const page = res || {}
          this.tableData = page.records || page.list || []
          this.total = page.total != null ? Number(page.total) : this.tableData.length
          if (page.current != null) {
            this.query.curPage = Number(page.current) || this.query.curPage
          }
          if (page.size != null) {
            this.query.pageSize = Number(page.size) || this.query.pageSize
          }
          this.$nextTick(() => this.bindRowDrag())
        })
        .finally(() => {
          this.loading = false
        })
    },
    refresh() {
      this.loadData()
    },
    handleSearch() {
      this.query.curPage = 1
      this.loadData()
    },
    handleReset() {
      this.query = {
        folderLevel1: '',
        folderLevel2: '',
        fileCode: '',
        fileName: '',
        version: '',
        preparer: '',
        status: null,
        curPage: 1,
        pageSize: this.query.pageSize
      }
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.curPage = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.query.curPage = page
      this.loadData()
    },
    getTbody() {
      const table = this.$refs.catalogTable
      if (!table || !table.$el) return null
      return table.$el.querySelector('.el-table__body-wrapper tbody')
    },
    unbindRowDrag() {
      const tbody = this._dragTbody
      if (!tbody || !this._dragHandlers) return
      const h = this._dragHandlers
      tbody.removeEventListener('dragstart', h.dragstart)
      tbody.removeEventListener('dragover', h.dragover)
      tbody.removeEventListener('drop', h.drop)
      tbody.removeEventListener('dragend', h.dragend)
      this._dragBound = false
      this._dragTbody = null
      this._dragHandlers = null
    },
    bindRowDrag() {
      const tbody = this.getTbody()
      if (!tbody) return
      if (this._dragBound && this._dragTbody === tbody) {
        this.markRowsDraggable(tbody)
        return
      }
      this.unbindRowDrag()
      const handlers = {
        dragstart: (e) => this.onDragStart(e),
        dragover: (e) => this.onDragOver(e),
        drop: (e) => this.onDrop(e),
        dragend: (e) => this.onDragEnd(e)
      }
      tbody.addEventListener('dragstart', handlers.dragstart)
      tbody.addEventListener('dragover', handlers.dragover)
      tbody.addEventListener('drop', handlers.drop)
      tbody.addEventListener('dragend', handlers.dragend)
      this._dragBound = true
      this._dragTbody = tbody
      this._dragHandlers = handlers
      this.markRowsDraggable(tbody)
    },
    markRowsDraggable(tbody) {
      Array.from(tbody.querySelectorAll('tr')).forEach(tr => {
        tr.removeAttribute('draggable')
        const handle = tr.querySelector('.drag-handle')
        if (handle) {
          handle.setAttribute('draggable', 'true')
        }
      })
    },
    onDragStart(e) {
      const handle = e.target.closest('.drag-handle')
      if (!handle) return
      const tr = handle.closest('tr')
      const tbody = this.getTbody()
      if (!tr || !tbody) return
      this.dragIndex = Array.from(tbody.children).indexOf(tr)
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', String(this.dragIndex))
      tr.classList.add('is-dragging')
    },
    onDragOver(e) {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
      const tr = e.target.closest('tr')
      if (!tr) return
      const tbody = this.getTbody()
      Array.from(tbody.children).forEach(row => row.classList.remove('is-drag-over'))
      tr.classList.add('is-drag-over')
    },
    onDrop(e) {
      e.preventDefault()
      const tr = e.target.closest('tr')
      const tbody = this.getTbody()
      if (!tr || !tbody || this.dragIndex < 0) return
      const dropIndex = Array.from(tbody.children).indexOf(tr)
      Array.from(tbody.children).forEach(row => row.classList.remove('is-drag-over'))
      if (dropIndex < 0 || dropIndex === this.dragIndex) return
      const list = this.tableData.slice()
      const [moved] = list.splice(this.dragIndex, 1)
      list.splice(dropIndex, 0, moved)
      this.tableData = list
      this.persistSort()
    },
    onDragEnd() {
      this.dragIndex = -1
      const tbody = this.getTbody()
      if (!tbody) return
      Array.from(tbody.children).forEach(row => {
        row.classList.remove('is-dragging', 'is-drag-over')
      })
    },
    persistSort() {
      const base = (this.query.curPage - 1) * this.query.pageSize
      const items = this.tableData.map((row, index) => {
        const sortNo = base + index + 1
        this.$set(row, 'sortNo', sortNo)
        return { fileId: row.fileId, sortNo }
      })
      this.sorting = true
      this.$HttpService.put('/file-info/catalog/sort', { items })
        .then(() => {
          this.$message.success('排序已保存')
        })
        .catch(() => {
          this.$message.error('排序保存失败')
          this.loadData()
        })
        .finally(() => {
          this.sorting = false
          this.$nextTick(() => this.bindRowDrag())
        })
    },
    formatFolderPath(row) {
      if (!row) return ''
      if (row.folderPath) return row.folderPath
      const parts = [row.folderLevel1, row.folderLevel2].filter(Boolean)
      return parts.join(' / ') || '-'
    },
    openFileLocation(row) {
      if (!row || !row.folderId) {
        this.$message.warning('未找到文件所在目录')
        return
      }
      this.$emit('open-location', row)
    },
    openPreview(row) {
      if (!row || !row.hasViewPermission) {
        this.$message.warning('暂无预览权限')
        return
      }
      if (!row.fileId) {
        this.$message.warning('文件信息不完整')
        return
      }
      this.previewRow = row
      const fileType = (row.fileType || '').toLowerCase()
      const support = this.$config.supportFile || {}
      const canView = (support.view || []).indexOf(fileType) !== -1
        || (support.windowView || []).indexOf(fileType) !== -1
      if (!canView) {
        this.previewUnsupported = true
        this.previewUrl = ''
        this.previewVisible = true
        return
      }
      this.previewUnsupported = false
      this.previewUrl = this.buildPreviewUrl(row)
      this.previewKey += 1
      this.previewVisible = true
    },
    buildPreviewUrl(row) {
      const token = this.$util.getToken()
      const base = this.$config.system.apiUrl
      const fileType = (row.fileType || '').toLowerCase()
      const support = this.$config.supportFile || {}
      if ((support.windowView || []).indexOf(fileType) !== -1) {
        return `${base}/file-info/viewFileByWindow/${row.fileId}?token=${token}`
      }
      return `${base}/file-info/viewFile/${row.fileId}?token=${token}`
    },
    closePreview() {
      this.previewVisible = false
      this.previewUrl = ''
      this.previewRow = {}
      this.previewUnsupported = false
    },
    openEdit(row) {
      this.editForm = {
        fileId: row.fileId,
        fileName: row.fileName || '',
        fileCode: row.fileCode || '',
        version: row.version || '',
        effectiveDate: row.effectiveDate || '',
        preparer: row.preparer || '',
        reviewer: row.reviewer || '',
        approver: row.approver || '',
        remark: row.remark || '',
        sortNo: row.sortNo != null ? Number(row.sortNo) : 0
      }
      this.editVisible = true
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    saveEdit() {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
        this.saving = true
        this.$HttpService.put('/file-info/catalog/update', { ...this.editForm })
          .then(() => {
            this.$message.success('保存成功')
            this.editVisible = false
            this.loadData()
          })
          .finally(() => {
            this.saving = false
          })
      })
    }
  }
}
</script>

<style scoped>
.file-catalog-panel {
  width: 100%;
  height: 100%;
  padding: 12px 16px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.search-form {
  flex-shrink: 0;
  margin-bottom: 4px;
}
.search-grid {
  width: 100%;
}
.search-form ::v-deep .el-form-item {
  margin-right: 0;
  margin-bottom: 12px;
  width: 100%;
}
.search-form ::v-deep .el-form-item__content {
  min-width: 0;
}
.search-form ::v-deep .el-input,
.search-form ::v-deep .el-select {
  width: 100%;
}
.search-actions {
  text-align: right;
}
.search-actions ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
@media (max-width: 767px) {
  .search-actions {
    text-align: left;
  }
  .search-actions ::v-deep .el-form-item__content {
    justify-content: flex-start;
  }
}
.sort-tip {
  flex-shrink: 0;
  margin: 0 0 10px;
  color: #909399;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.catalog-table-wrap {
  flex: 1;
  min-height: 280px;
  overflow: hidden;
}
.catalog-pagination {
  flex-shrink: 0;
  margin-top: 12px;
  text-align: right;
}
.drag-handle {
  cursor: grab;
  color: #909399;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.drag-handle:hover {
  color: #1e6fff;
  background: rgba(30, 111, 255, 0.08);
}
.drag-handle:active {
  cursor: grabbing;
}
.file-catalog-panel ::v-deep .ant-select {
  width: 100%;
  min-width: 0 !important;
}
.catalog-preview-unsupported {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: #909399;
  font-size: 14px;
}
.catalog-preview-iframe {
  width: 100%;
  height: 78vh;
  border: none;
  background: #f5f7fa;
}
</style>

<style>
.catalog-preview-dialog .el-dialog__body {
  padding: 8px 12px 12px;
}
.catalog-table .is-dragging {
  opacity: 0.55;
  background: #f0f7ff !important;
}
.catalog-table .is-drag-over {
  box-shadow: inset 0 2px 0 #1e6fff;
}
.catalog-table .drag-col .cell {
  padding-left: 0;
  padding-right: 0;
}
</style>
